import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {Observable} from 'rxjs';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {DatabaseNotification} from '@app/core/models/databaseNotification.model';
import {NotificationService as OldNotificationService} from '@app/modules/shared/services/notification.service';
import {map} from 'rxjs/operators';
import {AuthService, INotificationNumbers} from '@app/core/services/auth.service';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {

	constructor(
		private httpService: HttpService,
		public authService: AuthService,
		private oldNotificationService: OldNotificationService,
	) {
	}

	public newNotificationNumbersFromPrev(notificationNumbers: INotificationNumbers): INotificationNumbers {
		return {...notificationNumbers};
	}

	public getLatestNotifications(): Observable<DatabaseNotification[]> {
		return this.httpService.getJson<PaginationHolder<DatabaseNotification[]>>('notifications')
			.pipe(map(res => res.data.map(n => this.oldNotificationService.fresh(n))));
	}

	public getNotificationNumbers(): Observable<INotificationNumbers> {
		return this.httpService.getJson<INotificationNumbers>('notifications/numbers')
			.pipe(map(res => this.authService.formattedNotificationsVariable(res) as INotificationNumbers));
	}

	public markAllNotificationsAsRead(): Observable<{ success: boolean, error: {} }> {
		return this.httpService.patchJson<{ success: boolean, error: {} }>('notifications/markAllAsRead', {});
	}

	public markConversationAsRead(conversationId: number): Observable<unknown> {
		return this.httpService.postJson('notifications/readMessages/' + conversationId, {});
	}
}
